import { render, staticRenderFns } from "./recordAnalysis.vue?vue&type=template&id=406d2f34&scoped=true"
import script from "./recordAnalysis.vue?vue&type=script&lang=js"
export * from "./recordAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d2f34",
  null
  
)

export default component.exports